import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { MoreHorizontal } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BreadcrumbEllipsis',
  props: {
    class: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    "data-slot": "breadcrumb-ellipsis",
    role: "presentation",
    "aria-hidden": "true",
    class: _normalizeClass(_unref(cn)('flex size-9 items-center justify-center', props.class))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_unref(MoreHorizontal), { class: "size-4" })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "More", -1))
  ], 2))
}
}

})